// Carry Roll Air-density model — PSD §4.2.1. Pure function.
import { LAPSE_RATE, RHO_MAX, RHO_MIN, RV, RS, SEA_LEVEL_PRESSURE, SEA_LEVEL_TEMP, STD_BAROMETRIC_EXP, RANGE_TEMPERATURE_K, } from './constants';
/**
 * Air density combining altitude, temperature, humidity, pressure.
 * When seaLevelBaseline is true, standard sea-level values override for density only.
 * Range warnings are emitted by validate(); this function only clamps for computation.
 */
export function airDensity(env) {
    const warnings = [];
    let h0 = env.altitudeM;
    if (h0 < 0)
        h0 = 0;
    let T0 = env.seaLevelBaseline ? SEA_LEVEL_TEMP : env.temperatureK;
    const P0 = env.seaLevelBaseline ? SEA_LEVEL_PRESSURE : env.pressurePa;
    // Clamp inputs for computation (range warnings are owned by validate.ts)
    if (T0 < RANGE_TEMPERATURE_K[0])
        T0 = RANGE_TEMPERATURE_K[0];
    if (T0 > RANGE_TEMPERATURE_K[1])
        T0 = RANGE_TEMPERATURE_K[1];
    // Barometric formula for local temperature & pressure
    const T = T0 - LAPSE_RATE * h0;
    const TClamped = T < 200 ? 200 : T;
    const P = P0 * Math.pow(Math.max(1 - (LAPSE_RATE * h0) / T0, 1e-6), STD_BAROMETRIC_EXP);
    // Humidity clamp
    const hum = env.humidity < 0 ? 0 : env.humidity > 1 ? 1 : env.humidity;
    // Water vapour pressure (Magnus formula)
    const tc = TClamped - 273.15;
    const pv = hum * 6.1078 * Math.pow(10, (7.5 * tc) / (tc + 237.3));
    // Moist-air density
    const rhoDry = (P - pv) / (RS * TClamped);
    const rhoWet = pv / (RV * TClamped);
    const rho = rhoDry + rhoWet;
    const clamped = rho < RHO_MIN ? RHO_MIN : rho > RHO_MAX ? RHO_MAX : rho;
    return { rho: clamped, warnings };
}
//# sourceMappingURL=environment.js.map